import {mapGetters} from "vuex";
import remove from "../../mixins/remove";

export default {
    name: "product",
    data() {
        return {

        }
    },
    computed: {
        ...mapGetters({
            items: 'product/_getItems',
        }),
        headers() {
            return [
                {text: 'Title', value: "title"},
                {
                    text: 'Edit',
                    value: "actions",
                    align: "end",
                },
            ];
        },
    },
    methods: {
        removeItem() {
            this.$store.dispatch("product/deleteItem", this.selected);
            this.clearDialog();
        },
    },
    created() {
        this.$store.dispatch("product/getItems");
    },
    mixins: [remove],
};
